export * from './onPlayNewVideo';
//# sourceMappingURL=index.js.map